import React, { useState } from "react";
import { NavLink } from "react-router";
import useWindowSize from "../hooks/useWindowSize";

function Navbar() {
  let width = useWindowSize();
  const [isOpen, setIsOpen] = useState(false);
  const openMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      {width > 640 ? (
        <header className="w-full fixed top-0 z-50 justify-between font-primaria">
          <nav className="flex flex-row justify-between items-center">
            <div className="md:max-w-52 font-bold text-white px-2">
              <NavLink to="/">
                <img
                  src="https://innovativeld.com/assets/Logo-InnovativeLD.png"
                  alt="Innovative Land Developers"
                  className="w-full object-cover"
                />
              </NavLink>
            </div>
            <div className=" text-primario bg-secundario p-3 rounded-b-2xl font-bold">
              <ul className="flex gap-5 lg:text-xl">
                <li className="">
                  <NavLink to={"/"}> <span className="">Home </span> </NavLink>
                </li>
                <li className="">
                  <NavLink to="/services"> Services </NavLink>
                </li>
                <li className="">
                  <NavLink to="/projects"> Projects </NavLink>
                </li>
                <li className="">
                  <NavLink to="/about"> About </NavLink>
                </li>
              </ul>
            </div>
            <div className="px-2">
              <NavLink to="/consultation">
                <div className="text-lg px-4 py-2 bg-secundario rounded-lg font-semibold text-primario">
                  Book a Consultation
                </div>
              </NavLink>

            </div>
          </nav>

        </header>
      ) : (
        <header className="font-primaria">
          <div className="fixed top-5 right-0 z-50">
            <button
              onClick={openMenu}
              className="w-10 h-10 relative bg-primario rounded-full rounded-r-none"
            >
              <span
                className={`absolute transform left-1/2 -translate-x-1/2 top-1/3 translate-y-1/3  h-[3px]  transition-all duration-300 ease-in-out  ${
                  isOpen
                    ? "w-0 bg-transparent"
                    : "w-1/2 bg-secundario delay-200"
                }`}
              ></span>
              <span
                className={` absolute transform left-1/2 -translate-x-1/2 h-[3px] w-1/2  transition-all duration-500 ease-in-out origin-center bg-secundario  ${
                  isOpen ? "rotate-45" : "rotate-0"
                }`}
              ></span>
              <span
                className={`absolute transform left-1/2 -translate-x-1/2 h-[3px] w-1/2  transition-all duration-500 ease-in-out origin-center bg-secundario ${
                  isOpen ? "-rotate-45" : "rotate-0"
                }`}
              ></span>
              <span
                className={`absolute transform left-1/2 -translate-x-1/2 bottom-1/3 translate-y-1/3  h-[3px]  transition-all duration-300 ease-in-out  ${
                  isOpen
                    ? "w-0 bg-transparent"
                    : "w-1/2 bg-secundario delay-200"
                }`}
              ></span>
            </button>
          </div>
          <nav
            className={`fixed h-screen top-0 right-0 z-40 bg-primario transition-all duration-300 ease-in-out flex flex-col justify-center items-start ${
              isOpen ? "w-full" : "w-0 delay-300"
            }`}
          >
            <ul className="flex flex-col gap-5 text-5xl lg:text-xl p-5">
              <li className="text-secundario hover:text-white">
                <button onClick={openMenu}>
                  <NavLink to={"/"}> Home </NavLink>
                </button>
              </li>
              <li className="text-secundario hover:text-white">
                <button onClick={openMenu}>
                  <NavLink to="/services"> Services</NavLink>
                </button>
              </li>
              <li className="text-secundario hover:text-white">
                <button onClick={openMenu}>
                  <NavLink to="/projects"> Projects</NavLink>
                </button>
              </li>
              <li className="text-secundario hover:text-white">
                <button onClick={openMenu}>
                  <NavLink to="/about"> About </NavLink>
                </button>
              </li>
            </ul>
            <h1 className="absolute bottom-5 left-5 justify-self-end text-3xl text-white z-50">
              Innovative LD
            </h1>
          </nav>
        </header>
      )}
    </>
  );
}

export default Navbar;
